import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { Home, QuizCar } from '../pages';

export default function RoutesComponent() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quiz-car" element={<QuizCar/>} />
        <Route path="/quiz-car/:slug" element={<QuizCar/>} />

        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}
